import React, { useEffect, useRef, useState } from "react"
import "./calenderComponent.css"
import momentJalaali from 'moment-jalaali';
import { Calendar } from 'react-datepicker2';

const CalenderComponent = (props) => {
    const [calOne, setCalOne] = useState({ value: momentJalaali() })
    const [calTWo, setcalTWo] = useState({ value: momentJalaali().subtract(1, "jMonths") })
    const [range, setRange] = useState({})
    const wrapperRef = useRef(null);


    useEffect(() => {
        setRange({ start: momentJalaali(props.value.start), end: momentJalaali(props.value.end) })
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);
    useEffect(async () => {
        selectDefaultValues()
    }, [props.defaultValues]);

    useEffect(async () => {

        setRangeInCal()
    }, [calTWo, calOne])
    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        }
    };
    const selectDefaultValues = () => {
        setCalOne({ value: momentJalaali() })
        setcalTWo({ value: momentJalaali().subtract(1, "jMonths") })
        switch (props.defaultValues) {
            case "امروز": {
                clickHandler(momentJalaali(), 'calendar')
                clickHandler(momentJalaali(), 'calendar')
            }
                break
            case "دیروز": {
                clickHandler(momentJalaali().subtract(1, "day"), 'calendar')
                clickHandler(momentJalaali().subtract(1, "day"), 'calendar')
            }
                break
            case "هفته اخیر": {
                clickHandler(momentJalaali().subtract(7, "day"), 'calendar')
                clickHandler(momentJalaali(), 'calendar')
            }
                break
            case "هفته قبل": {
                clickHandler(momentJalaali().subtract(14, "day"), 'calendar')
                clickHandler(momentJalaali().subtract(7, "day"), 'calendar')
            }
                break
            case "ماه اخیر": {
                clickHandler(momentJalaali().subtract(30, "day"), 'calendar')
                clickHandler(momentJalaali(), 'calendar')
            }
                break
            case "ماه قبل": {
                clickHandler(momentJalaali().subtract(60, "day"), 'calendar')
                clickHandler(momentJalaali().subtract(30, "day"), 'calendar')

            }
                break
        }

    }

    const removeFromAllCalendar = (className) => {
        const days = document.querySelectorAll(".calendar .dayWrapper.currentMonth");
        days.forEach((item, index) => {
            days[index].classList.remove(className);
        })
        const days2 = document.querySelectorAll(".calendarTwo .dayWrapper.currentMonth");
        days2.forEach((item, index) => {
            days2[index].classList.remove(className);
        })
    }
    const setRangeInCal = () => {
        removeFromAllCalendar('rangeStart')
        removeFromAllCalendar('rangeEnd')
        removeFromAllCalendar('selectedRange')
        if (typeof range.start !== "undefined" && typeof range.end !== "undefined") {
            const days = document.querySelectorAll(".calendar .dayWrapper.currentMonth");
            const days2 = document.querySelectorAll(".calendarTwo .dayWrapper.currentMonth");
            setTimeout(() => {
                calOne.value.jMonth() === range.start.jMonth() ? days[range.start.jDate() - 1]?.classList.add("rangeStart") :
                    (calTWo.value.jMonth() === range.start.jMonth() ? days2[range.start.jDate() - 1]?.classList.add("rangeStart") : days2[range.start.jDate() - 1].classList.remove("rangeStart"))

                calOne.value.jMonth() === range.end.jMonth() ? days[range.end.jDate() - 1]?.classList.add("rangeEnd") :
                    (calTWo.value.jMonth() === range.end.jMonth() ? days2[range.end.jDate() - 1]?.classList.add("rangeEnd") : days2[range.end.jDate() - 1]?.classList.remove("rangeEnd"))
            }, 50);
            days.forEach((item, index) => {
                checkRange(index, calOne) && days[index]?.classList.add("selectedRange")
            })
            days2.forEach((item, index) => {
                checkRange(index, calTWo) && days2[index]?.classList.add("selectedRange")
            })
        }
    }

    const checkRange = (day, calendar) => {
        let temp = momentJalaali(calendar.value);
        temp = temp.subtract(temp.jDate() - 1, "day")
        temp = temp.add(day, "day")
        let end = momentJalaali(range.end)
        if (temp.toDate() > range.start && temp.toDate() < end) {
            return true
        }
    }

    const clickHandler = (value, calendar) => {
        let Range = range
        if (!Range.start && !Range.end) {
            Range.start = value;
            setRange({ ...Range });

            let temp = "." + calendar + " " + ".dayWrapper.currentMonth";
            const days = document.querySelectorAll(temp);
            days[value.jDate() - 1] && days[value.jDate() - 1].classList.add("customSelected")

        } else if (Range.start && !Range.end) {
            if (value < Range.start) {
                Range.end = Range.start;
                Range.start = value
            } else {
                Range.end = value;
            }
            setRange({ ...Range });
            props.exportRange({ ...range })
            removeFromAllCalendar('customSelected')
            const days = document.querySelectorAll(".calendar .dayWrapper.currentMonth");
            const days2 = document.querySelectorAll(".calendarTwo .dayWrapper.currentMonth");
            setTimeout(() => {
                calOne.value.jMonth() === range.start.jMonth() ? days[Range.start.jDate() - 1].classList.add("rangeStart") :
                    (calTWo.value.jMonth() === range.start.jMonth() ? days2[Range.start.jDate() - 1].classList.add("rangeStart") : days2[Range.start.jDate() - 1].classList.remove("rangeStart"))

                calOne.value.jMonth() === range.end.jMonth() ? days[Range.end.jDate() - 1].classList.add("rangeEnd") :
                    (calTWo.value.jMonth() === range.end.jMonth() ? days2[Range.end.jDate() - 1].classList.add("rangeEnd") : days2[Range.end.jDate() - 1].classList.remove("rangeEnd"))
            }, 50);
            days.forEach((item, index) => {
                checkRange(index, calOne) && days[index].classList.add("selectedRange")
            })
            days2.forEach((item, index) => {
                checkRange(index, calTWo) && days2[index].classList.add("selectedRange")
            })


        }
        // }
        else {
            removeFromAllCalendar('rangeStart')
            removeFromAllCalendar('rangeEnd')
            removeFromAllCalendar('selectedRange')
            delete Range.end
            Range.start = value;
            setRange({ ...Range });
        }
    }

    const setMonth = async (value) => {
        let val = { ...calTWo };
        val.value = momentJalaali(value).subtract(1, "jMonths")
        setCalOne({ value: momentJalaali(value) })
        setcalTWo({ ...val })
    }
    const setPrevMonth = (value) => {
        let val = { ...calTWo };
        setCalOne({ ...calTWo })
        val.value = momentJalaali(value)
        setcalTWo({ ...val })
    }

    return <div className="calendarWrapper" ref={wrapperRef}>
        <div className="calendar">
            <Calendar
                onMonthChange={value => {
                    setMonth(value)
                }}
                selectedDay={calOne.value}
                isGregorian={false}
                onChange={value => {
                    clickHandler(value, 'calendar')
                }}
                showTodayButton={false}
            />
            <br />

        </div>

        <div className='lines'></div>
        <div className='calendarTwo'>
            <Calendar
                selectedDay={calTWo.value}
                isGregorian={false}
                onMonthChange={value => {
                    setPrevMonth(value)
                }}
                onChange={value => {
                    clickHandler(value, 'calendarTwo')
                }}
                showTodayButton={false}
            />
        </div>
    </div>
}


export default CalenderComponent;